/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationCertificateType,
    ApplicationCertificateTypeFromJSON,
    ApplicationCertificateTypeFromJSONTyped,
    ApplicationCertificateTypeToJSON,
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApplicationCertificateTypeProgramTypeResponse
 */
export interface ApplicationCertificateTypeProgramTypeResponse {
    /**
     * 
     * @type {Date}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    applicationCertificateTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    programTypeId: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    required: boolean;
    /**
     * 
     * @type {Option}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    programType?: Option;
    /**
     * 
     * @type {ApplicationCertificateType}
     * @memberof ApplicationCertificateTypeProgramTypeResponse
     */
    applicationCertificateType?: ApplicationCertificateType;
}

export function ApplicationCertificateTypeProgramTypeResponseFromJSON(json: any): ApplicationCertificateTypeProgramTypeResponse {
    return ApplicationCertificateTypeProgramTypeResponseFromJSONTyped(json, false);
}

export function ApplicationCertificateTypeProgramTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationCertificateTypeProgramTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'applicationCertificateTypeId': json['applicationCertificateTypeId'],
        'programTypeId': json['programTypeId'],
        'required': json['required'],
        'programType': !exists(json, 'programType') ? undefined : OptionFromJSON(json['programType']),
        'applicationCertificateType': !exists(json, 'applicationCertificateType') ? undefined : ApplicationCertificateTypeFromJSON(json['applicationCertificateType']),
    };
}

export function ApplicationCertificateTypeProgramTypeResponseToJSON(value?: ApplicationCertificateTypeProgramTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'applicationCertificateTypeId': value.applicationCertificateTypeId,
        'programTypeId': value.programTypeId,
        'required': value.required,
        'programType': OptionToJSON(value.programType),
        'applicationCertificateType': ApplicationCertificateTypeToJSON(value.applicationCertificateType),
    };
}


